import { Link } from '@tanstack/react-router';
import { LazyMotion, m } from 'motion/react';
import { domAnimation } from '@/lib/motionFeatures';
import { useReducedMotion } from '@/hooks/useReducedMotion';
import notFoundImage from '@/assets/images/http-error.svg';
import { tw } from '@/lib/tailwind';

export default function PageNotFound() {
  const prefersReducedMotion = useReducedMotion();

  const containerMotionConfig = prefersReducedMotion
    ? {}
    : {
        initial: { opacity: 0, y: -10 },
        animate: { opacity: 1, y: 0 },
        transition: { duration: 0.3, ease: 'easeOut' as const },
      };

  const imageMotionConfig = prefersReducedMotion
    ? {}
    : { initial: { scale: 0.95 }, animate: { scale: 1 }, transition: { duration: 0.3, ease: 'easeOut' as const } };

  return (
    <LazyMotion features={domAnimation}>
      {/* A `div`, not a `main`: this renders inside AppLayout's `<main>` */}
      <div
        className={tw('flex min-h-[calc(100vh-var(--dashboard-menu-height))] w-full items-center justify-center')}
        role="alert"
        aria-labelledby="error-heading"
      >
        <m.div
          className="flex flex-col items-center gap-5"
          {...containerMotionConfig}
        >
          <m.img
            src={notFoundImage}
            alt="Page Not Found"
            role="presentation"
            className="mb-4"
            {...imageMotionConfig}
          />
          <h1
            id="error-heading"
            className="text-2xl"
          >
            Page Cannot Be Found
          </h1>
          <p
            className="text-center text-sm"
            aria-label="Navigation suggestion"
          >
            This page doesn&apos;t exist, or the address has moved
            <br />
            Go back to the&nbsp;
            <Link
              className={
                'text-primary-700! hover:text-primary-800 focus:ring-billiard-700 rounded underline focus:ring-2 focus:outline-none'
              }
              to="/"
              aria-label="Return to Overview page"
            >
              Overview
            </Link>
            &nbsp;page
          </p>
        </m.div>
      </div>
    </LazyMotion>
  );
}
